import React from "react";
import MobileViewDashboard from "../../../user/dashboard/MobileViewDashboard";
import DesktopView from "./dashboard/Home";

export default function StudentDashboard({
  profile,
  announcements,
  communities,
  events,
  eventListLoading,
  communityLoading,
  people,
  peopleLoading,
}) {
  return (
    <>
      <div className="desktop_view">
        <DesktopView
          announcements={announcements}
          profile={profile}
          communities={communities}
          communityLoading={communityLoading}
          events={events}
          eventListLoading={eventListLoading}
          people={people}
          peopleLoading={peopleLoading}
        />
      </div>
      <div className="mobile_view">
        <MobileViewDashboard
          announcements={announcements}
          profile={profile}
          communities={communities}
          communityLoading={communityLoading}
          events={events}
          eventListLoading={eventListLoading}
          people={people}
          peopleLoading={peopleLoading}
        />
      </div>
    </>
  );
}
